import moment from "moment";

export const dateAccessHelper = (access_open, access_close) => {
    const now = moment();

    if (access_open === undefined || access_close === undefined){
        //date control set to true, but dates are null
        return false;
    }

    return (moment(access_open).isBefore(now) && moment(access_close).isAfter(now));
};

export const submissionAccessHelper = (submission_open, submission_close) => {
    const now = moment();

    if (submission_open === undefined || submission_close === undefined){
        //date control set to true, but dates are null
        return false;
    }

    return (moment(submission_open).isBefore(now) && moment(submission_close).isAfter(now));
};

export const uploadAccessHelper = (upload_open, upload_close) => {
    const now = moment();

    if (upload_open === undefined || upload_close === undefined){
        //date control set to true, but dates are null
        return false;
    }

    return (moment(upload_open).isBefore(now) && moment(upload_close).isAfter(now));
};


/** WEBPACK FOOTER **
 ** ./src/helpers/accessHelper.js
 **/